import { render, staticRenderFns } from "./CentroTerapiasEspeciaisComponente.vue?vue&type=template&id=09653798&scoped=true"
import script from "./CentroTerapiasEspeciaisComponente.vue?vue&type=script&lang=js"
export * from "./CentroTerapiasEspeciaisComponente.vue?vue&type=script&lang=js"
import style0 from "./CentroTerapiasEspeciaisComponente.vue?vue&type=style&index=0&id=09653798&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09653798",
  null
  
)

export default component.exports